(function () {
  'use strict';

  angular.module('app').component('clientCommissionSeasonList', clientCommissionSeasonList());

  function clientCommissionSeasonList() {
    return {
      bindings: {
        client: '=',
        clientCommissionSeasons: '=',
        priceLists: '<',
      },
      controller: ClientCommissionSeasonListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/clients/components/client-commission-seasons/client-commission-season-list/client-commission-season-list.component.html',
    };
  }

  ClientCommissionSeasonListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    '$timeout',
    'ClientCommissionSeasonService',

    // Angular downgraded service
    'seasonService',
    'seasonModalService',
  ];

  function ClientCommissionSeasonListComponent(
    config,
    UtilService,
    AbilityService,
    $timeout,
    ClientCommissionSeasonService,

    // Angular downgraded service
    seasonService,
    seasonModalService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_client_accountadmin'),
      canShow: AbilityService.can('show_client_accountadmin'),
      canUpdate: AbilityService.can('update_client_accountadmin'),
      canDestroy: AbilityService.can('destroy_client_accountadmin'),
    };

    // vm.dateDisplay = config.DATE_DISPLAY;
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    // Methods
    // vm.filterByCurrentSeasons = filterByCurrentSeasons;
    vm.groupSeasonsByYears = groupSeasonsByYears;
    vm.openSeasonsModal = openSeasonsModal;

    vm.showAvailableSeasonsPopover = showAvailableSeasonsPopover;
    vm.hideAvailableSeasonsPopover = hideAvailableSeasonsPopover;

    vm.addClientCommissionSeason = addClientCommissionSeason;
    vm.removeClientCommissionSeason = removeClientCommissionSeason;
    vm.showClientCommissionSeason = showClientCommissionSeason;

    vm.onClientCommissionSeasonSaved = onClientCommissionSeasonSaved;
    vm.onClientCommissionSeasonDeleted = onClientCommissionSeasonDeleted;
    vm.onClientCommissionSeasonCanceled = onClientCommissionSeasonCanceled;

    vm.$onInit = function () {
      vm.clientCommissionSeasons = seasonService.setCurrentSeasons(vm.clientCommissionSeasons);

      // Load current client profile season
      if (vm.clientCommissionSeasons.length > 0) {
        showClientCommissionSeason(vm.clientCommissionSeasons[0], 'view');
      }

      // Initializers
      getSeasons();
    };

    // ----- SEASONS ----- //

    // Get active seasons
    function getSeasons(showAvailableSeasonsMode = false) {
      // current, where to is equal or less than today, check utc
      seasonService.getSeasons({ get: 'current', skip_check_role: true }).subscribe((response) => {
        vm.seasons = response.filter((season) => season.name); // In case of empty translation

        getAvailableSeasons(showAvailableSeasonsMode);
      });
    }

    function groupSeasonsByYears(season) {
      return seasonService.groupSeasonsByYears(season);
    }

    // Display only current seasons and avoid duplicate seasons, except the current season
    // function filterByCurrentSeasons(currentSeasonId) {
    //     return function(seasonItem) {
    //         return seasonService.filterByCurrentSeasons(seasonItem, currentSeasonId, [], vm.today);
    //     };
    // }

    function openSeasonsModal() {
      vm.showAvailableSeasonsMode = false;

      var successCallback = function () {
        getSeasons(true);
      };

      seasonModalService.openSeasonsModal(successCallback);
    }

    function getAvailableSeasons(showAvailableSeasonsMode = false) {
      var currentSeasons = [];
      vm.clientCommissionSeasons.forEach(function (clientCommissionSeason) {
        currentSeasons.push({ id: clientCommissionSeason.season_id });
      });

      vm.availableSeasons = vm.UtilService.getAvailableItemsInTwoArrays(
        vm.seasons,
        currentSeasons,
        'id'
      );

      vm.season = null;

      // To re-open popover if there are seasons after closing de seasons modal
      if (vm.availableSeasons.length > 0 && showAvailableSeasonsMode) {
        vm.showAvailableSeasonsMode = true;
      }
    }

    function showAvailableSeasonsPopover() {
      vm.showAvailableSeasonsMode = true;
    }

    function hideAvailableSeasonsPopover() {
      vm.showAvailableSeasonsMode = false;
      vm.season = null;
    }

    function addClientCommissionSeason(clientCommissionSeason) {
      if (!vm.permissions.canCreate) {
        return;
      }

      vm.mode = 'create';

      vm.clientCommissionSeason = null;
      $timeout(function () {
        // Hack
        if (clientCommissionSeason) {
          vm.clientCommissionSeason = clientCommissionSeason;
          return;
        }

        vm.clientCommissionSeason = {
          season_id: vm.season.id,
          season: {
            name: vm.season.name,
            from: vm.season.from,
            to: vm.season.to,
          },
          new: true,
        };

        hideAvailableSeasonsPopover();

        // Append season to clientCommissionSeasons
        vm.clientCommissionSeasons.push(vm.clientCommissionSeason);
        getAvailableSeasons();
      }, 50);
    }

    function removeClientCommissionSeason(index) {
      vm.clientCommissionSeasons.splice(index, 1);
      getAvailableSeasons();

      vm.showAvailableSeasonsMode = false;
      vm.clientCommissionSeason = null;
      vm.mode = null;
    }

    function showClientCommissionSeason(clientCommissionSeason, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.mode = mode || 'view';

      if (!clientCommissionSeason.id) {
        addClientCommissionSeason(clientCommissionSeason);
        return;
      }

      hideAvailableSeasonsPopover();

      vm.clientCommissionSeason = null;
      vm.loadingClientCommissionSeason = true;
      ClientCommissionSeasonService.getClientCommissionSeason(
        clientCommissionSeason,
        vm.client.id
      ).then(function (data) {
        vm.clientCommissionSeason = data;

        vm.loadingClientCommissionSeason = false;
      });
    }

    function onClientCommissionSeasonSaved(response) {
      delete vm.clientCommissionSeason.new;
    }

    function onClientCommissionSeasonDeleted(idSeasonDeleted) {
      var indexItemDeleted = vm.UtilService.findArrayIndex(
        vm.clientCommissionSeasons,
        'id',
        idSeasonDeleted
      );
      removeClientCommissionSeason(indexItemDeleted);
    }

    function onClientCommissionSeasonCanceled(mode) {
      if (mode !== 'edit') {
        vm.clientCommissionSeason = null;
        vm.mode = null;

        if (mode === 'create') {
          var indexItemToCreate = vm.UtilService.findArrayIndex(
            vm.clientCommissionSeasons,
            'new',
            true
          );
          removeClientCommissionSeason(indexItemToCreate);
        }

        return;
      }

      showClientCommissionSeason(vm.clientCommissionSeason, 'view');
    }
  }
})();
